<template>
  <div>
    <h1 class="mb-0">{{ $t("public.views.recoverPwd.title") }}</h1>
    <p>
      {{ $t("public.views.recoverPwd.text") }}
    </p>
    <form class="mt-4 form-auth-pages">
      <b-form-group label="Email: *" label-for="email">
        <b-form-input v-model="email" type="text" v-bind:class="{
          'text-danger': isFormEmailErrors,
          'is-invalid': isFormEmailErrors,
        }" @blur="checkEmail(email, emailInUse2)"></b-form-input>
        <ul v-if="isFormEmailErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('email')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <div class="d-inline-block w-100">
        <b-button ref="btnVolver" class="btn btn-primary float-right ml-2" variant="primary" @click="routeBack">{{
          $t("public.views.recoverPwd.btnBack")
        }}
        </b-button>
        <b-button class="btn btn-success float-right ml-2" variant="success" @click="saveFormStep1">{{
          $t("public.views.recoverPwd.btnReset")
        }}
        </b-button>
      </div>
    </form>
    <notifications group="notificacions" />
  </div>
</template>
<script>
import routes from "../../router/index";

//JSON Mock
import SignFooter from "../../json/SignFooter";

import validator from "vue-m-validator";

import utilsService from "../../services/utils";

export default {
  name: "RecoverPassword",
  data() {
    return {
      //Form registrate
      emailInUse2: false,
      email: "",

      footerMenu: SignFooter,

      validatorStep1: validator,
    };
  },
  mounted() {
    this.cleanFormStep1();
  },
  computed: {
    //Form step 1
    isFormEmailErrors() {
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      if (RULE_2_REGEXP.test(this.email)) {
        this.getCheckEmail(this.email);
      }
      let errors = this.validatorStep1.getErrors("email");
      return errors && errors.length > 0;
    },
  },
  methods: {
    routeBack() {
      this.$router.push({ name: "public.signin" });
    },
    notFirst() {
      this.isFirstRun = false;
    },
    cleanFormStep1() {
      this.emailInUse2 = false;
      this.email = "";
      this.validatorStep1.errors = [];
    },
    checkFormStep1() {
      this.checkEmail(this.email, this.emailInUse2);
    },
    saveFormStep1() {
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        this.sendPasswordForgot(this.email);
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t("public.views.recoverPwd.notification.error"),
          text: this.$i18n.t(
            "public.views.recoverPwd.notification.descErrorStep1"
          ),
          type: "error",
        });
      }
    },
    checkEmail(_email, checkEmail) {
      const EMAIL = _email.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t("public.views.recoverPwd.errors.erEmail"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t("public.views.recoverPwd.errors.erEmail1"),
      };
      const RULE_3 = {
        expression: !checkEmail,
        name: "email",
        msg: this.$i18n.t("public.views.recoverPwd.errors.erEmail2"),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2).addRule(RULE_3);
      this.notFirst();
    },
    getCheckEmail(email) {
      let self = this;

      utilsService
        .checkEmail(email)
        .then((response) => {
          if (response) {
            self.emailInUse2 = response.data;
            self.checkEmail(this.email, response.data);
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
    sendPasswordForgot(email) {
      let self = this;

      this.$awn.asyncBlock(
        utilsService.sendPasswordForgot(email),
        (response) => {
          if (response) {
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t("public.views.recoverPwd.notification.title"),
              text: this.$i18n.t(
                "public.views.recoverPwd.notification.descSendPwd"
              ),
              type: "success",
            });
            routes.push({ name: "public.signin" });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "utilsService.sendNewPassword",
            module: "view-authpages-recoverPassword",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              email: email
            })
          });
        },
        " "
      );
    },
  },
};
</script>
